import {
    DATASET_DRY_CARGO,
    DATASET_LNG,
    DATASET_SPECIALISED,
    DATASET_TANKERS,
} from '_legacy/models/Datasets';

const balticRateIndices = [
    {
        value: 'BCI',
        label: 'BCI',
        datasetIds: [DATASET_DRY_CARGO],
    },
    {
        value: 'BPI82',
        label: 'BPI 82',
        datasetIds: [DATASET_DRY_CARGO],
    },
    {
        value: 'BPI74',
        label: 'BPI 74',
        datasetIds: [DATASET_DRY_CARGO],
    },
    {
        value: 'BEPASIA',
        label: 'BEP ASIA',
        datasetIds: [DATASET_DRY_CARGO],
    },
    {
        value: 'BSI63',
        label: 'BSI 63',
        datasetIds: [DATASET_DRY_CARGO],
    },
    {
        value: 'BSI58',
        label: 'BSI 58',
        datasetIds: [DATASET_DRY_CARGO],
    },
    {
        value: 'BSI52',
        label: 'BSI 52',
        datasetIds: [DATASET_DRY_CARGO],
    },
    {
        value: 'BESASIA',
        label: 'BES ASIA',
        datasetIds: [DATASET_DRY_CARGO],
    },
    {
        value: 'BHI38',
        label: 'BHI 38',
        datasetIds: [DATASET_DRY_CARGO],
    },
    {
        value: 'BHI28',
        label: 'BHI 28',
        datasetIds: [DATASET_DRY_CARGO],
    },
    {
        value: 'TC1',
        label: 'TC1',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TC2_37',
        label: 'TC2_37',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TC5',
        label: 'TC5',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TC6',
        label: 'TC6',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TC7',
        label: 'TC7',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TC8',
        label: 'TC8',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TC9',
        label: 'TC9',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TC10',
        label: 'TC10',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TC11',
        label: 'TC11',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TC12',
        label: 'TC12',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TCDATASET_DRY_CARGO',
        label: 'TCDATASET_DRY_CARGO',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TCDATASET_TANKERS',
        label: 'TCDATASET_TANKERS',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TC16',
        label: 'TC16',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TC17',
        label: 'TC17',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TC18',
        label: 'TC18',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TC19',
        label: 'TC19',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD1',
        label: 'TD1',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD2',
        label: 'TD2',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD3C',
        label: 'TD3C',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD6',
        label: 'TD6',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD7',
        label: 'TD7',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD8',
        label: 'TD8',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD9',
        label: 'TD9',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TDDATASET_DRY_CARGO',
        label: 'TDDATASET_DRY_CARGO',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TDDATASET_TANKERS',
        label: 'TDDATASET_TANKERS',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD17',
        label: 'TD17',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD18',
        label: 'TD18',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD19',
        label: 'TD19',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD20',
        label: 'TD20',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD21',
        label: 'TD21',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD22',
        label: 'TD22',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD23',
        label: 'TD23',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD24',
        label: 'TD24',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD25',
        label: 'TD25',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'TD26',
        label: 'TD26',
        datasetIds: [DATASET_SPECIALISED, DATASET_TANKERS],
    },
    {
        value: 'BLNG1_174',
        label: 'BLNG1-174',
        datasetIds: [DATASET_LNG],
    },
    {
        value: 'BLNG2_174',
        label: 'BLNG2-174',
        datasetIds: [DATASET_LNG],
    },
    {
        value: 'BLNG3_174',
        label: 'BLNG3-174',
        datasetIds: [DATASET_LNG],
    },
    {
        value: 'BLNG1g',
        label: 'BLNG1(g)',
        datasetIds: [DATASET_LNG],
    },
    {
        value: 'BLNG2g',
        label: 'BLNG2(g)',
        datasetIds: [DATASET_LNG],
    },
    {
        value: 'BLNG3g',
        label: 'BLNG3(g)',
        datasetIds: [DATASET_LNG],
    },
];

const balticRateIndicesWithId = balticRateIndices.map((value, index) => {
    return { ...value, id: index + 1 };
});

export const getBalticRateIndicesByDatasetId = (datasetId) => {
    return balticRateIndicesWithId.filter((index) =>
        index.datasetIds.includes(datasetId)
    );
};

export const getBalticIndexByValue = (value) => {
    return balticRateIndicesWithId.find((index) => index.value === value);
};
